// extracted by mini-css-extract-plugin
module.exports = {"container":"BackToHome_container__2pkA3","icon":"BackToHome_icon__WmwN6"};